/* LeParfin : puces de filtre (maquette V3).
   Utilisé par la collection (familles), la page Avis (parfums) et la page FAQ (onglets).
   Conteneur [data-lp-chips] ; puces [data-filter="cle"] (« tous » = tout afficher) ;
   éléments [data-filter-item="cle1 cle2"] ; [data-filter-all] visibles seulement sans filtre ;
   [data-filter-empty] affiché quand rien ne correspond. Le filtre suit l'ancre de l'adresse (#cle). */
(() => {
  'use strict';

  const ALL = 'tous';
  const keyOf = el => (el.getAttribute('data-filter') || '').trim();
  const isAll = k => k === '' || k === ALL;

  function setup(root) {
    if (!root || root.__lpChips) return;
    const chips = [...root.querySelectorAll('[data-filter]')];
    if (!chips.length) return;
    root.__lpChips = true;

    const row = root.querySelector('.chips');
    const items = [...root.querySelectorAll('[data-filter-item]')];
    const allOnly = [...root.querySelectorAll('[data-filter-all]')];
    const empty = root.querySelector('[data-filter-empty]');
    const allChip = chips.find(c => isAll(keyOf(c)));

    function apply(key, fromUser) {
      const chip = chips.find(c => keyOf(c) === key) || allChip || chips[0];
      const k = keyOf(chip);
      const all = isAll(k);
      chips.forEach(c => {
        const on = c === chip;
        c.classList.toggle('on', on);
        c.setAttribute('aria-current', on ? 'true' : 'false');
      });
      let shown = 0;
      items.forEach(it => {
        const keys = (it.getAttribute('data-filter-item') || '').split(/[\s,]+/);
        const vis = all || keys.includes(k);
        it.hidden = !vis;
        if (vis) shown += 1;
      });
      allOnly.forEach(t => { t.hidden = !all; });
      if (empty) empty.hidden = shown > 0;
      if (row) row.scrollLeft = chip.offsetLeft - row.offsetLeft - 20;
      if (fromUser && window.history && window.history.replaceState) {
        const url = all ? window.location.pathname + window.location.search : '#' + encodeURIComponent(k);
        window.history.replaceState(window.history.state, '', url);
      }
    }

    const hashKey = () => { try { return decodeURIComponent(window.location.hash.slice(1)); } catch (e) { return ''; } };
    const known = k => chips.some(c => keyOf(c) === k);

    root.addEventListener('click', e => {
      const c = e.target.closest('[data-filter]');
      if (!c || !root.contains(c)) return;
      e.preventDefault();
      apply(keyOf(c), true);
    });

    window.addEventListener('hashchange', () => {
      const h = hashKey();
      if (known(h)) apply(h, false);
    });

    const h = hashKey();
    const current = chips.find(c => c.classList.contains('on'));
    apply(known(h) ? h : (current ? keyOf(current) : (allChip ? keyOf(allChip) : keyOf(chips[0]))), false);
  }

  const init = (scope = document) => {
    if (scope.matches && scope.matches('[data-lp-chips]')) setup(scope);
    scope.querySelectorAll('[data-lp-chips]').forEach(setup);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
